import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { KIND_LABELS } from "@/lib/options";

const NEW_GROUP = { name: "", kind: "complemento", required: false, min: 1, max: "", options: [{ name: "", price: "" }] };

function OptionRows({ g, gi, upd }) {
  const setOpt = (oi, patch) => upd({ options: g.options.map((o, j) => (j === oi ? { ...o, ...patch } : o)) });
  return (
    <div className="space-y-2">
      {g.options.map((o, oi) => (
        <div key={oi} className="flex gap-2">
          <Input value={o.name} placeholder="Nome da opção" onChange={(e) => setOpt(oi, { name: e.target.value })} data-testid={`group-${gi}-option-name-${oi}`} />
          <Input type="number" step="0.01" value={o.price} placeholder="+ R$" className="w-28" onChange={(e) => setOpt(oi, { price: e.target.value })} data-testid={`group-${gi}-option-price-${oi}`} />
          <Button type="button" size="icon" variant="ghost" onClick={() => upd({ options: g.options.filter((_, j) => j !== oi) })}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="ghost" onClick={() => upd({ options: [...g.options, { name: "", price: "" }] })} data-testid={`group-${gi}-add-option-btn`}><Plus className="h-4 w-4 mr-1" />Opção</Button>
    </div>
  );
}

export function OptionGroupsEditor({ groups, onChange, extra }) {
  const upd = (i, patch) => onChange(groups.map((g, j) => (j === i ? { ...g, ...patch } : g)));
  return (
    <div className="space-y-3" data-testid="option-groups-editor">
      <p className="text-xs text-muted-foreground">Crie grupos de adicionais, complementos ou variações. Defina se o grupo é obrigatório e quantas opções o cliente pode escolher.</p>
      {groups.map((g, i) => (
        <div key={i} className="rounded-lg border p-3 space-y-3" data-testid={`option-group-${i}`}>
          <div className="flex gap-2">
            <Input value={g.name} placeholder="Nome do grupo (ex.: Escolha o molho)" onChange={(e) => upd(i, { name: e.target.value })} data-testid={`group-name-${i}`} />
            <select value={g.kind || "adicional"} onChange={(e) => upd(i, { kind: e.target.value })} className="rounded-md border bg-transparent px-2 text-sm" data-testid={`group-kind-${i}`}>
              {Object.entries(KIND_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
            <Button type="button" size="icon" variant="ghost" onClick={() => onChange(groups.filter((_, j) => j !== i))} data-testid={`group-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
          </div>
          <div className="flex flex-wrap items-center gap-4 text-sm">
            <label className="flex items-center gap-2"><Switch checked={!!g.required} onCheckedChange={(v) => upd(i, { required: v, min: v ? Math.max(1, Number(g.min) || 1) : 0 })} data-testid={`group-required-${i}`} />Obrigatório</label>
            <label className={`flex items-center gap-2 ${g.required ? "" : "opacity-40"}`}>Mínimo<Input type="number" min="1" disabled={!g.required} value={g.required ? g.min : ""} onChange={(e) => upd(i, { min: e.target.value })} className="h-8 w-16" data-testid={`group-min-${i}`} /></label>
            <label className="flex items-center gap-2">Máximo<Input type="number" min="1" value={g.max ?? ""} placeholder="∞" onChange={(e) => upd(i, { max: e.target.value })} className="h-8 w-16" data-testid={`group-max-${i}`} /></label>
          </div>
          <OptionRows g={g} gi={i} upd={(patch) => upd(i, patch)} />
        </div>
      ))}
      <div className="flex flex-wrap gap-2">
        <Button type="button" size="sm" variant="outline" onClick={() => onChange([...groups, { ...NEW_GROUP, options: [{ name: "", price: "" }] }])} data-testid="add-option-group-btn"><Plus className="h-4 w-4 mr-1" />Adicionar grupo</Button>
        {extra}
      </div>
    </div>
  );
}

export const cleanGroups = (groups) => groups
  .map((g) => ({ name: g.name.trim(), kind: g.kind || "adicional", required: !!g.required, min: g.required ? Math.max(1, Number(g.min) || 1) : 0, max: Number(g.max) || (g.type === "single" ? 1 : null), options: g.options.filter((o) => o.name.trim()).map((o) => ({ name: o.name.trim(), price: Number(o.price) || 0 })) }))
  .filter((g) => g.name && g.options.length);
